import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=1238c918&lang=pug"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports